export default __webpack_public_path__ + "static/media/tongue.6e584760.png";